export enum DBOperation {
  create = 1,
  update = 2,
  delete = 3
}

export enum DataStatus {
  SUCCESS = 1,
  FAILED = 2,
  PARTIAL = 3
}

export enum ProductStatus {
  NotForSale = 1,
  Active = 2,
  Discontinued = 3
}

export enum ControlDisplayMode {
  AutoComplete = 1,
  Popup = 2,
  Dropdown = 3
}

export enum ReminderDisplayMode {
  Button = 1,
  Card = 2,
  Text = 3,
  Comments = 4,
  Date = 5,
  CommentsWithTypes = 6
}

export enum ReminderTypes {
  Payment = 1,
  Invoice = 2,
  Membership = 3,
  Subscription = 4,
  Personal = 5,
  General = 6,
  Inquiry = 7
}

export enum DataFor {
  Product = 1,
  Brand = 2,
  Category = 3,
  Country = 4,
  Location = 5,
  Tax = 6,
  Customer = 7,
  Distributor = 8,
  Member = 9,
  MembershipPlan = 10,
  UserMembershipPlan = 11,
  UserMembershipPlanTemplate = 12,
  BodyPart = 13,
  MeasurementUnit = 14,
  Gender = 15,
  User = 16,
  Employee = 17,
  Trainer = 18,
  Dietician = 19,
  UserStage = 20
}

export enum MaritalStatus {
  MARRIED = 1,
  UNMARRIED = 2,
  SEPARATED = 3
}

export enum GENDER {
  MALE = 1,
  FEMALE = 2,
  TRANSGENDER = 3,
  OTHER = 4
}

export enum AddressType {
  Billing = 1,
  Communication = 2,
  Other = 3
}

export enum UserType {
  OWNER = 1,
  ADMIN = 2,
  EMPLOYEE = 3,
  TRAINER = 4,
  DIETICIAN = 5,
  MEMBER = 6,
  CUSTOMER = 7,
  CONTRACTOR = 8,
  STAFF = 9,
  GUEST = 10
}

export enum JoinCondition {
  AND = 1,
  OR = 2
}
export enum FilterOperator {
  Equals = 1,
  In = 2,
  Contains = 3,
  StartsWith = 4,
  EndsWith = 5
}

export enum ReportResultType {
  Grid = 1,
  Excel = 2,
  Pdf = 3,
  ObjectList = 4
}

export enum DateType {
  Registration = 'Registration',
  Subscription = 'Subscription',
  Followup = 'Followup'
}

export enum NotificationMedium {
  Email = 1,
  SMS = 2,
  Mobile = 3,
  Whatsapp = 4
}
